
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  getPayWayStatistics,
  getMembershipPayWay,
  getPayWayStatisticsShop,
  getMembershipPayWayShop,
} from "@/api/shouyin";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import CustomTable from "@/components/CustomTable/index.vue";
import PieChart from "@/components/PieChart/index.vue";

// 付款方式详情
@Component({
  components: {
    DimensionSelect,
    SearchPopup,
    CustomTable,
    PieChart,
  },
})
export class PaymentMethodDetail extends Vue {
  @Getter companyId!: string;
  @Getter isMultiStore!: boolean;
  @Getter multiStoreList!: Array<any>;
  tabList = ["购买商品付款方式", "充值会员付款方式"];
  activeTab = 0;
  params: any = {};

  dimension = "门店";
  dimensionValue = "1";
  showTotal = false;

  searchRes = null;

  columns = [
    {
      key: "payName",
      title: "购买商品付款方式",
    },
    {
      key: "percentage",
      title: "占比",
      align: "right",
      width: 60,
      dataType: "percent",
    },
    {
      key: "orderMoney",
      title: "支付金额",
      order: "",
      align: "right",
      width: 90,
      dataType: "amount",
    },
    {
      key: "payNumber",
      title: "笔数",
      align: "right",
      width: 70,
    },
  ];
  tableDataSourceScroll = [];
  config: any = {
    type: "percent",
    data: [
      { name: "微信", value: 0, dataType: "money" },
      { name: "支付宝", value: 0, dataType: "money" },
      { name: "储值卡", value: 0, dataType: "money" },
      { name: "收款码", value: 0, dataType: "money" },
      { name: "现金", value: 0, dataType: "money" },
    ],
  };

  payMethod = [
    { name: "微信", value: 0, dataType: "money" },
    { name: "支付宝", value: 0, dataType: "money" },
    { name: "储值卡", value: 0, dataType: "money" },
    { name: "收款码", value: 0, dataType: "money" },
    { name: "现金", value: 0, dataType: "money" },
  ];

  memberMethod = [
    { name: "微信", value: 0, dataType: "money" },
    { name: "支付宝", value: 0, dataType: "money" },
    { name: "收款码", value: 0, dataType: "money" },
    { name: "现金", value: 0, dataType: "money" },
  ];

  @Watch("params")
  onParamsChange() {
    this.getData();
  }

  async getData() {
    this.config.data = [];
    this.tableDataSourceScroll = [];
    if (this.activeTab === 0) {
      this.columns[0].title = "购买商品付款方式";
      this.columns[2].key = "orderMoney";
      let res: any;
      if (this.isMultiStore) {
        const params = {
          orderType: this.params.orderType,
          queryTimeBegin: this.params.queryTimeBegin,
          queryTimeEnd: this.params.queryTimeEnd,
          storeList: this.multiStoreList.map((item) => {
            return { storeId: item };
          }),
        };
        res = await getPayWayStatisticsShop(params, true);
      } else {
        res = await getPayWayStatistics(this.params, true);
      }

      this.payMethod.forEach((dItem) => {
        const item = res.data.find((i) => i.payName === dItem.name);
        dItem.value = Math.round((item?.percentage ?? 0) * 10000) / 100;
      });
      this.config.data = this.payMethod;
      if (res.data.length === 0) {
        this.tableDataSourceScroll = [];
        return;
      }
      this.tableDataSourceScroll = this.payMethod.map((dItem) => {
        let item = res.data.find((i) => i.payName === dItem.name);
        if (!item) {
          item = {
            orderMoney: 0,
            payName: dItem.name,
            payNumber: 0,
            percentage: 0,
            totalMoney: 0,
          };
        }
        return item;
      });
    } else {
      this.columns[0].title = "充值会员付款方式";
      this.columns[2].key = "topUpAmount";

      let res: any;
      if (this.isMultiStore) {
        const params = {
          orderType: this.params.orderType,
          queryTimeBegin: this.params.queryTimeBegin,
          queryTimeEnd: this.params.queryTimeEnd,
          storeList: this.multiStoreList.map((item) => {
            return { storeId: item };
          }),
        };
        res = await getMembershipPayWayShop(params, true);
      } else {
        res = await getMembershipPayWay(this.params, true);
      }
      this.memberMethod.forEach((dItem) => {
        const item = res.data.find((i) => i.payName === dItem.name);
        dItem.value = Math.round((item?.percentage ?? 0) * 10000) / 100;
      });
      this.config.data = this.memberMethod;
      if (res.data.length === 0) {
        this.tableDataSourceScroll = [];
        return;
      }
      this.tableDataSourceScroll = this.memberMethod.map((dItem) => {
        let item = res.data.find((i) => i.payName === dItem.name);
        if (!item) {
          item = {
            topUpAmount: 0,
            payName: dItem.name,
            payNumber: 0,
            percentage: 0,
            totalMoney: 0,
          };
        }
        return item;
      });
    }
  }

  onDimensionConfirm(name: string, value: string) {
    this.dimension = name;
    this.dimensionValue = value;
    this.params.orderType = value;
    this.getData();
  }

  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      orderType: this.dimensionValue,
      storeId: this.companyId,
    };
  }

  tabChange(tab: string) {
    this.getData();
  }
  mounted() {
    const queryObj = this.$route.query;

    if (!Object.keys(queryObj).length || queryObj?.isWorkbench !== "1") {
      return;
    }

    const pObj: any = { ...this.params };

    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
        this.dimensionValue = pObj.orderType;
      }
    }
    this.params = pObj;
  }
}
export default PaymentMethodDetail;
